import { defaultLocale } from "@/i18n/defaults";
import { useCallback } from "react";

// serialize postcode for countries
export const serializePostcode = (input: string): string => {
  // Remove all non-digit characters
  const digitsOnly = input.replace(/[^0-9]/g, "");

  // Polish postcode format: XX-XXX
  if (defaultLocale === "pl") {
    if (digitsOnly.length === 0) return "";
    if (digitsOnly.length <= 2) return digitsOnly;
    if (digitsOnly.length <= 5)
      return `${digitsOnly.slice(0, 2)}-${digitsOnly.slice(2)}`;
    return `${digitsOnly.slice(0, 2)}-${digitsOnly.slice(2, 5)}`;
  }

  // Czech postcode format: XXX XX
  if (defaultLocale === "cz") {
    if (digitsOnly.length === 0) return "";
    if (digitsOnly.length <= 3) return digitsOnly;
    if (digitsOnly.length <= 5)
      return `${digitsOnly.slice(0, 3)} ${digitsOnly.slice(3)}`;
    return `${digitsOnly.slice(0, 3)} ${digitsOnly.slice(3, 5)}`;
  }

  return input;
};

export const useSerializedPostCode = () => {
  const serializedPostcode = useCallback((input: string): string => {
    return serializePostcode(input);
  }, []);

  return { serializePostcode: serializedPostcode };
};

export const postCodeRegex = () => {
  if (defaultLocale === "pl") {
    return /^\d{2}-\d{3}$/;
  }
  if (defaultLocale === "cz") {
    return /^\d{3} \d{2}$/;
  }
  return /^\d{2}-\d{3}$/;
};
